/**
 * Video Loader
 * 
 * Performance optimization that conditionally loads videos based on screen size:
 * - Desktop (1024px+): Loads hero videos, media panels, and block media
 * - Mobile (<1024px): Only loads block media to save bandwidth
 * 
 * Converts lazy-loaded videos (data-src) to active videos (src) and triggers loading.
 * 
 * Video Types:
 * - Hero videos: [data-hero-video] (unified selector for all hero components)
 * - Media panels: .media-panel__video (featured content panels)
 * - Block media: .block__media (StreamField content blocks)
 */
export default () => {
    let allVideos = [];

    if (window.matchMedia('(min-width: 1024px)').matches) {
        // Desktop: Load all video types including bandwidth-heavy hero videos
        allVideos = Array.prototype.slice.call(
            document.querySelectorAll(
                '.media-panel__video, [data-hero-video], .block__media'
            )
        );
    } else {
        // Mobile: Only load essential block media videos to preserve bandwidth
        allVideos = Array.prototype.slice.call(
            document.querySelectorAll(
                '.block__media'
            )
        );
    }
    
    if (allVideos.length > 0) {
        allVideos.forEach((video) => {
            const videoSource = video.children[0];
            // Convert lazy-loaded videos (data-src) to active videos (src)
            if (videoSource && videoSource.dataset.src) {
                videoSource.setAttribute('src', videoSource.dataset.src);
                video.load();
            }
        });
    }
};
